// extracted by mini-css-extract-plugin
module.exports = {"OrderItemName":"OrderItemName_OrderItemName__3NM4p","Name":"OrderItemName_Name__2-YeR","ExternalButton":"OrderItemName_ExternalButton__L7XJL"};